export const QuotedRateNotifiedIcon = ({ color = "#009F5C" }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="13"
      viewBox="0 0 11 13"
      fill="none"
    >
      <path
        d="M6.41732 0.583984V2.91732C6.41732 3.22674 6.54023 3.52348 6.75903 3.74228C6.97782 3.96107 7.27457 4.08398 7.58398 4.08398H9.91732M3.50065 8.16732L4.66732 9.33398L7.00065 7.00065M7.00065 0.583984H1.75065C1.44123 0.583984 1.14449 0.706901 0.925693 0.925693C0.706901 1.14449 0.583984 1.44123 0.583984 1.75065V11.084C0.583984 11.3934 0.706901 11.6902 0.925693 11.9089C1.14449 12.1277 1.44123 12.2507 1.75065 12.2507H8.75065C9.06007 12.2507 9.35682 12.1277 9.57561 11.9089C9.7944 11.6902 9.91732 11.3934 9.91732 11.084V3.50065L7.00065 0.583984Z"
        stroke={color}
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
